export default "__VITE_ASSET__BfqjnUro__"